import { createSelector } from 'reselect'

const data = state => state.sucursalesReducer.getIn(["sucursales"])
export const sucursalesSelector = createSelector(
  data, (dataField) => {      
    return dataField.toJS ? dataField.toJS() : dataField
  }
)

const sucursal = state => state.sucursalesReducer.getIn(["sucursal"])
export const sucursalEditSelector = createSelector(
  sucursal, (dataField) => {      
    return dataField.toJS ? dataField.toJS() : dataField
  }
)